import { OnrsrPortalUser } from "../../models/onrsr-portal-user";

export class GetOnrsrPortalUsers {
    static onrsrPortalUsers: OnrsrPortalUser[] = [
        {
          "Id": 1,
          "FullName": "Sophie Taylor",
          "Title": "Returns Coordinator",
          "OperatorRoles": "Monthly Returns, Occurrences, Report",
          "Email": "sophie.taylor@southernrail.com.au",
          "WorkPhone": "03 9123 4510",
          "WorkMobile": "0401 223 901"
        },
        {
          "Id": 2,
          "FullName": "Mark Chen",
          "Title": "Systems Administrator",
          "OperatorRoles": "Organisation Administrator, Ontology",
          "Email": "mark.chen@southernrail.com.au",
          "WorkPhone": "03 9123 4511",
          "WorkMobile": "0402 334 882"
        },
        {
          "Id": 3,
          "FullName": "Olivia Hart",
          "Title": "Compliance Officer",
          "OperatorRoles": "Notification of Change, Organisation Details",
          "Email": "olivia.hart@southernrail.com.au",
          "WorkPhone": "03 9123 4512",
          "WorkMobile": "0403 991 204"
        },
        {
          "Id": 4,
          "FullName": "James O'Neill",
          "Title": "Safety Analyst",
          "OperatorRoles": "Occurrences, Ontology, Report",
          "Email": "james.oneill@southernrail.com.au",
          "WorkPhone": "03 9123 4513",
          "WorkMobile": "0404 118 663"
        },
        {
          "Id": 5,
          "FullName": "Emma Rodriguez",
          "Title": "Data Manager",
          "OperatorRoles": "Monthly Returns, Report, Ontology",
          "Email": "emma.rodriguez@southernrail.com.au",
          "WorkPhone": "03 9123 4514",
          "WorkMobile": "0405 776 320"
        },
        {
          "Id": 6,
          "FullName": "Noah Patel",
          "Title": "Change Coordinator",
          "OperatorRoles": "Notification of Change, Organisation Details, Occurrences",
          "Email": "noah.patel@southernrail.com.au",
          "WorkPhone": "03 9123 4515",
          "WorkMobile": "0406 443 210"
        },
        {
          "Id": 7,
          "FullName": "Grace Wilson",
          "Title": "Reporting Officer",
          "OperatorRoles": "Report, Monthly Returns",
          "Email": "grace.wilson@southernrail.com.au",
          "WorkPhone": "03 9123 4516",
          "WorkMobile": "0407 225 908"
        },
        {
          "Id": 8,
          "FullName": "Ethan Wright",
          "Title": "Ontology Coordinator",
          "OperatorRoles": "Ontology, Organisation Administrator",
          "Email": "ethan.wright@southernrail.com.au",
          "WorkPhone": "03 9123 4517",
          "WorkMobile": "0408 664 731"
        },
        {
          "Id": 9,
          "FullName": "Chloe Martin",
          "Title": "Administration Officer",
          "OperatorRoles": "Organisation Details, Monthly Returns, Report",
          "Email": "chloe.martin@southernrail.com.au",
          "WorkPhone": "03 9123 4518",
          "WorkMobile": "0409 118 552"
        },
        {
          "Id": 10,
          "FullName": "Jack Thompson",
          "Title": "Operations Liaison",
          "OperatorRoles": "Occurrences, Notification of Change",
          "Email": "jack.thompson@southernrail.com.au",
          "WorkPhone": "03 9123 4519",
          "WorkMobile": "0410 552 884"
        }
      ]
}